import axios, { AxiosInstance } from "axios";
import app_config from "../environment/environment";
import { getCookie } from "../utils/cookie";

export const http = (url: string = "api_url") => {
  const http = axios.create({ baseURL: app_config[url] });

  http.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error)
  );

  http.interceptors.response.use(
    (config) => config,
    (error) => {
      handleError(error);
      return Promise.reject(error);
    }
  );


  const authToken = getCookie(app_config.auth_token);
  
  authToken && setAuthToken(http, authToken);

  return http;
};

export const setAuthToken = (http: AxiosInstance, token: string) => {
  http.defaults.headers["Authorization"] = "Bearer " + token;
};

const handleError = (error: any) => {
  console.log(error,"handleerr");
  
  // if (error.response.status == "400") {
  //   console.log(new error(error));
  // }
};
